<template>
	<div class="kangfu_button">
		<div
			class="kangfu_button_item"
			v-for="item in list"
			:key="item"
			:class="item === val ? 'select_item':''"
			@click="onClick(item)"
		>
			<div class="content">{{ item }}</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'kangfuButton',
    props: {
        list: {
            type: Array,
            default: () => []
        },
        value: {
            type: String,
            default: '全部'
        }
    },
    computed: {
        val: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        onClick (item) {
            this.val = item
        }
    }
}
</script>
<style lang="less" scoped>
.kangfu_button {
	&_item {
		padding: 32px 0;
		font-size: 28px;
		text-align: center;
		display: flex;
		.content {
			flex: 1;
		}
	}
	.select_item {
		background-color: #f5f6f7;
		display: flex;
		align-items: center;
		&::before {
			content: '';
			display: inline-block;
			width: 8px;
			height: 35px;
			background-color: @primary;
			margin-right: 5px;
		}
	}
}
</style>